import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  display: none;
  position: absolute;
  left: -15px;
  bottom: 0;

  @media only screen and (min-width: 768px) {
    display: unset;
  }
`;

export default Wrapper(template);
